export interface ITooltipAttributes {
  text: string;
  position?: TooltipPosition;
  multiline?: boolean;
  color?: TooltipColor;
  alwaysActive?: boolean;
  nowrap?: boolean;
}

export type TooltipPosition = 'top' | 'right' | 'bottom' | 'left';
export type TooltipColor = 'primary' | 'info' | 'success' | 'warning' | 'danger';
